import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, normalizeStyle as _normalizeStyle, Fragment as _Fragment, normalizeClass as _normalizeClass, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "tp-course-teacher mb-15" }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = ["src"]
const _hoisted_4 = { class: "tp-course-thumb" }
const _hoisted_5 = ["src", "alt"]
const _hoisted_6 = { class: "tp-course-content" }
const _hoisted_7 = { class: "tp-course-tag mb-10" }
const _hoisted_8 = { class: "tp-course-meta" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("span", null, [
  /*#__PURE__*/_createElementVNode("svg", {
    width: "15",
    height: "14",
    viewBox: "0 0 15 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    /*#__PURE__*/_createElementVNode("path", {
      d: "M13.9228 10.0426V2.29411C13.9228 1.51825 13.2949 0.953997 12.5252 1.01445H12.4847C11.1276 1.12529 9.07163 1.82055 7.91706 2.53596L7.80567 2.6065C7.62337 2.71733 7.30935 2.71733 7.11692 2.6065L6.9549 2.50573C5.81046 1.79033 3.75452 1.1152 2.3974 1.00437C1.62768 0.943911 0.999756 1.51827 0.999756 2.28405V10.0426C0.999756 10.6573 1.50613 11.2417 2.12393 11.3122L2.30622 11.3425C3.70386 11.5238 5.87126 12.2392 7.10685 12.9143L7.1372 12.9244C7.30937 13.0252 7.59293 13.0252 7.75498 12.9244C8.99057 12.2393 11.1681 11.5339 12.5758 11.3425L12.7885 11.3122C13.4164 11.2417 13.9228 10.6674 13.9228 10.0426Z",
      stroke: "#94928E",
      "stroke-width": "1.2",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }),
    /*#__PURE__*/_createElementVNode("path", {
      d: "M7.46118 2.81787V12.4506",
      stroke: "#94928E",
      "stroke-width": "1.2",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    })
  ])
], -1 /* HOISTED */)
const _hoisted_10 = /*#__PURE__*/_createElementVNode("span", null, [
  /*#__PURE__*/_createElementVNode("svg", {
    width: "13",
    height: "15",
    viewBox: "0 0 13 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    /*#__PURE__*/_createElementVNode("path", {
      d: "M6.57134 7.5C8.36239 7.5 9.81432 6.04493 9.81432 4.25C9.81432 2.45507 8.36239 1 6.57134 1C4.7803 1 3.32837 2.45507 3.32837 4.25C3.32837 6.04493 4.7803 7.5 6.57134 7.5Z",
      stroke: "#94928E",
      "stroke-width": "1.2",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }),
    /*#__PURE__*/_createElementVNode("path", {
      d: "M12.1426 14C12.1426 11.4845 9.64553 9.44995 6.57119 9.44995C3.49684 9.44995 0.999756 11.4845 0.999756 14",
      stroke: "#94928E",
      "stroke-width": "1.2",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    })
  ])
], -1 /* HOISTED */)
const _hoisted_11 = { class: "tp-course-title" }
const _hoisted_12 = { class: "tp-course-rating d-flex align-items-end justify-content-between" }
const _hoisted_13 = { class: "tp-course-rating-star" }
const _hoisted_14 = /*#__PURE__*/_createElementVNode("span", null, " /5", -1 /* HOISTED */)
const _hoisted_15 = {
  class: "tp-course-rating-icon",
  style: {"margin-top":"5px"}
}
const _hoisted_16 = { class: "course-star-rating" }
const _hoisted_17 = /*#__PURE__*/_createStaticVNode("<div class=\"back-stars\"><i class=\"fa fa-star\"></i><i class=\"fa fa-star\"></i><i class=\"fa fa-star\"></i><i class=\"fa fa-star\"></i><i class=\"fa fa-star\"></i></div>", 1)
const _hoisted_18 = /*#__PURE__*/_createStaticVNode("<i class=\"fa fa-star\"></i><i class=\"fa fa-star\"></i><i class=\"fa fa-star\"></i><i class=\"fa fa-star\"></i><i class=\"fa fa-star\"></i>", 5)
const _hoisted_23 = [
  _hoisted_18
]
const _hoisted_24 = { class: "tp-course-pricing home-2" }
const _hoisted_25 = { key: 0 }
const _hoisted_26 = { key: 1 }
const _hoisted_27 = { class: "tp-course-btn home-2" }

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_router_link = _resolveComponent("router-link")

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["tp-course-item p-relative fix mb-30", $props.cssClass]),
    style: _normalizeStyle($props.cssStyle)
  }, [
    _createElementVNode("div", _hoisted_1, [
      ($props.course.instructor?.name)
        ? (_openBlock(), _createElementBlock("span", _hoisted_2, [
            _createElementVNode("img", {
              src: ($props.course.instructor.user_image)?$props.course.instructor.user_image:'/assets/lms_website/images/user.png',
              alt: ""
            }, null, 8 /* PROPS */, _hoisted_3),
            _createTextVNode(" " + _toDisplayString($props.course.instructor?.full_name), 1 /* TEXT */)
          ]))
        : _createCommentVNode("v-if", true)
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createVNode(_component_router_link, {
        to: `/courses/view/${$props.course.name}`
      }, {
        default: _withCtx(() => [
          _createElementVNode("img", {
            class: "course-sky",
            src: ($props.course.image)?$props.course.image:'/assets/lms_website/images/placeholder.jpg',
            alt: $setup.lms_website.__($props.course.title)
          }, null, 8 /* PROPS */, _hoisted_5)
        ]),
        _: 1 /* STABLE */
      }, 8 /* PROPS */, ["to"])
    ]),
    _createElementVNode("div", _hoisted_6, [
      _createElementVNode("div", _hoisted_7, [
        _createElementVNode("span", null, _toDisplayString($setup.lms_website.__($props.course.tags)), 1 /* TEXT */)
      ]),
      _createElementVNode("div", _hoisted_8, [
        _createElementVNode("span", null, [
          _hoisted_9,
          _createTextVNode(" " + _toDisplayString($props.course.lesson_count) + " " + _toDisplayString($setup.lms_website.__('Lessons')), 1 /* TEXT */)
        ]),
        _createElementVNode("span", null, [
          _hoisted_10,
          _createTextVNode(" " + _toDisplayString($props.course.enrollment_count) + " " + _toDisplayString($setup.lms_website.__('Students')), 1 /* TEXT */)
        ])
      ]),
      _createElementVNode("h4", _hoisted_11, [
        _createVNode(_component_router_link, {
          to: `/courses/view/${$props.course.name}`
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString($options.clip($setup.lms_website.__($props.course.title), 75)), 1 /* TEXT */)
          ]),
          _: 1 /* STABLE */
        }, 8 /* PROPS */, ["to"])
      ]),
      _createElementVNode("div", _hoisted_12, [
        _createElementVNode("div", _hoisted_13, [
          _createElementVNode("p", null, [
            _createTextVNode(_toDisplayString($options.floatVale($props.course.avg_rating)), 1 /* TEXT */),
            _hoisted_14
          ]),
          _createElementVNode("div", _hoisted_15, [
            _createElementVNode("div", _hoisted_16, [
              _hoisted_17,
              _createElementVNode("div", {
                class: "front-stars",
                style: _normalizeStyle('width:'+$options.avg_rating_width($props.course.avg_rating))
              }, _hoisted_23, 4 /* STYLE */)
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_24, [
          (!$props.course.paid_course)
            ? (_openBlock(), _createElementBlock("span", _hoisted_25, _toDisplayString($setup.lms_website.__('Free')), 1 /* TEXT */))
            : _createCommentVNode("v-if", true),
          ($props.course.paid_course)
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                ($props.course?.custom_course_sale_price)
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                      _createElementVNode("del", null, _toDisplayString($options.format_currency($props.course.course_price)), 1 /* TEXT */),
                      _createElementVNode("span", null, _toDisplayString($options.format_currency($props.course.custom_course_sale_price)), 1 /* TEXT */)
                    ], 64 /* STABLE_FRAGMENT */))
                  : (_openBlock(), _createElementBlock("span", _hoisted_26, _toDisplayString($options.format_currency($props.course.course_price)), 1 /* TEXT */))
              ], 64 /* STABLE_FRAGMENT */))
            : _createCommentVNode("v-if", true)
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_27, [
      _createVNode(_component_router_link, {
        to: `/courses/view/${$props.course.name}`
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString($setup.lms_website.__('Preview this Course')), 1 /* TEXT */)
        ]),
        _: 1 /* STABLE */
      }, 8 /* PROPS */, ["to"])
    ])
  ], 6 /* CLASS, STYLE */))
}